var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container"},[_c('editor',{ref:"editorRef",attrs:{"id":"tinymce-editor","init":_vm.init},model:{value:(_vm.contentData),callback:function ($$v) {_vm.contentData=$$v},expression:"contentData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }